<template>
  <div class="parent-container">
    <div class="parent-toolbar">
      <WidgetToolbar title="School" :icon="require('@/assets/admin-icon/menu/school_active.svg')">
        <div class="options">
          <div class="row"></div>
        </div>
      </WidgetToolbar>
    </div>
    <div class="manage-consultant-profile-wrapper">
      <div class="manage-sections">
        <div class="profile-section">
          <div class="tab-header">
            <div class="tab-top-header">
              <h1>
                Manage {{ profile_data.user.first_name | validate }}
                {{ profile_data.user.last_name | validate }} Profile
              </h1>
              <!-- Dropdown -->
              <dropdown-menu class="dropdown-menu">
                <ul>
                  <li>
                    <a href @click.prevent="requestToMarge(id)">Request to Merge</a>
                  </li>
                </ul>
              </dropdown-menu>
              <!-- End of dropdown -->
            </div>

            <div class="tabs-widget">
              <div class="tabs-links">
                <div class="tab" style="justify-content: flex-start" :class="{ active: tab_type == 'gen' }"
                  @click="switchTab('gen')">
                  <span class="name">Public information</span>
                  <span class="icon">
                    <img v-if="tab_type == 'gen'"
                      src="@/assets/icons/consultant-profile-icons/general-infos-active.svg" />
                    <img v-else src="@/assets/icons/consultant-profile-icons/general-infos.svg" />
                  </span>
                </div>
                <div class="tab" :class="{ active: tab_type == 'proj' }" @click="switchTab('proj')">
                  <span class="name">Projects</span>
                  <span class="icon">
                    <img v-if="tab_type == 'proj'" src="@/assets/icons/consultant-profile-icons/projects-active.svg" />
                    <img v-else src="@/assets/icons/consultant-profile-icons/projects.svg" />
                  </span>
                </div>
                <div class="tab" :class="{ active: tab_type == 'skills' }" @click="switchTab('skills')">
                  <span class="name">Skills</span>
                  <span class="icon">
                    <img v-if="tab_type == 'skills'" src="@/assets/icons/consultant-profile-icons/skills-active.svg" />
                    <img v-else src="@/assets/icons/consultant-profile-icons/skills.svg" />
                  </span>
                </div>
                <div class="tab" :class="{ active: tab_type == 'emply' }" @click="switchTab('emply')">
                  <span class="name">Employment</span>
                  <span class="icon">
                    <img v-if="tab_type == 'emply'" src="@/assets/icons/consultant-profile-icons/employment-active.svg" />
                    <img v-else src="@/assets/icons/consultant-profile-icons/employment.svg" />
                  </span>
                </div>
                <div class="tab" style="justify-content: flex-end" :class="{ active: tab_type == 'qualif' }"
                  @click="switchTab('qualif')">
                  <span class="name">Qualification</span>
                  <span class="icon">
                    <img v-if="tab_type == 'qualif'"
                      src="@/assets/icons/consultant-profile-icons/qualification-active.svg" />
                    <img v-else src="@/assets/icons/consultant-profile-icons/qualification.svg" />
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- Tab body section -->
          <div class="tab-body">
            <PublicInformation :id="id" :company_id="company_id" v-if="tab_type == 'gen'"></PublicInformation>
            <Project :id="id" :company_id="company_id" v-if="tab_type == 'proj'"></Project>
            <Skills :id="id" :company_id="company_id" v-if="tab_type == 'skills'"></Skills>
            <Employment :id="id" :company_id="company_id" v-if="tab_type == 'emply'"></Employment>
            <Qualification :id="id" :company_id="company_id" v-if="tab_type == 'qualif'"></Qualification>
          </div>
        </div>
      </div>
      <!-- Pop up -->
      <div class="overlay-modal" v-if="showPopUp">
        <div class="box-content">
          <div class="content-widget">
            <p>
              This is a copy of the actual consultant’s profile, Any change you
              make will not be applied to the original profile, unless you
              select to apply the changes
            </p>
          </div>
          <div class="content-option" @click="showPopUp = false">Proceed</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PublicInformation from "./ManageConsultantComponets/PublicInformation.vue";
import Employment from "./ManageConsultantComponets/Employment.vue";
import Project from "./ManageConsultantComponets/Project.vue";
import Qualification from "./ManageConsultantComponets/Qualification.vue";
import Skills from "./ManageConsultantComponets/Skills.vue";

export default {
  name: "consultants",
  components: {
    Employment,
    Project,
    PublicInformation,
    Qualification,
    Skills,
  },

  data: () => {
    return {
      showPopUp: false,
      tab_type: "gen",
      profile_data: {
        user: {},
        projects: [],
        skills: [],
        employment: [],
        educations: [],
        trainings: [],
        certifications: [],
      },
      showExport: true,
      id: null,
      company_id: null,
    };
  },
  mounted() {
    let vm = this;
    vm.id = vm.$route.query.id;
    vm.company_id = vm.$route.query.company_id;
    if (vm.id && vm.company_id) {
      vm.getConsultantData(vm.id);
    } else {
      vm.closeProfile();
    }
  },
  computed: {},
  methods: {
    requestToMarge(user_id) {
      let vm = this;
      vm.$store
        .dispatch("COMPANY_REQUEST_MARGER_PROFILE_TO_CONSULTANT", {
          company_id: vm.company_id,
          user_id: user_id,
        })
        .then((responce) => {
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Now request was sent",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Warning",
            text: "Request not sent, Please try again.",
            type: "warn",
            duration: 3000,
          });
          console.log(error);
        });
    },
    removeConsultant(user_id) {
      let vm = this;
      let names =
        vm.profile_data.user.first_name + " " + vm.profile_data.user.last_name;
      vm.$store
        .dispatch("REMOVE_MEMBER_FROM_COMPANY", {
          company_id: vm.company_id,
          user_id: user_id,
        })
        .then((responce) => {
          vm.closeProfile();
          vm.$notify({
            group: "status",
            title: "Success",
            text: names + " was removed from this company",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Warning",
            text: "Error while removing this member, Please try again.",
            type: "warn",
            duration: 3000,
          });
          console.log(error);
        });
    },
    getConsultantData(id) {
      let vm = this;
      vm.$store
        .dispatch("GET_CONSULTANT_ALL_DATA", { id: id })
        .then((responce) => {
          vm.profile_data = responce.data;
          vm.showPopUp = true;
        })
        .catch((error) => {
          console.log({ error });
        });
    },
    switchTab(type) {
      let vm = this;
      vm.tab_type = type;
    },
    closeProfile() {
      let vm = this;
      vm.$emit("close");
    },
  },
};
</script>
<style lang="scss" scoped>
.parent-container {
  display: flex;
  flex-direction: column;
  height: 100%;

  .parent-toolbar {
    position: absolute;
    z-index: 999;
    top: 5px;
    left: 5px;
    right: 5px;
  }

  .manage-consultant-profile-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .manage-sections {
      display: flex;
      height: 100%;
      width: 100%;

      @media (min-width: 300px) and (max-width: 630px) {
        grid-template-columns: 100%;
      }

      .profile-section {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;

        .tab-header {
          display: flex;
          flex-direction: column;
          width: 100%;
          height: 117px;
          background: #fff;
          border-top-right-radius: 5px;
          border-top-left-radius: 5px;
          margin-bottom: 15px;

          .tab-top-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 21px 17px;

            h1 {
              margin: 0px;
              font-size: 22px;
            }
          }

          .tabs-widget {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            border-bottom: 1px solid #efefef;

            .tabs-links {
              display: grid;
              width: 100%;
              grid-template-columns: 20% 20% 20% 20% 20%;

              @media (min-width: 300px) and (max-width: 630px) {
                width: 100%;
                padding: 0px 0px;
                grid-template-columns: 20% 20% 20% 20% 20%;
              }

              .tab {
                text-align: center;
                cursor: pointer;
                height: 50px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: #f4f4f4;
                padding: 0px 20px;

                @media (min-width: 300px) and (max-width: 630px) {
                  font-size: 12px;
                }

                .name {
                  display: block;

                  @media (min-width: 300px) and (max-width: 630px) {
                    display: none;
                  }
                }

                .icon {
                  display: none;
                  background: #dedede;
                  height: 40px;
                  width: 40px;
                  justify-content: center;
                  align-items: center;
                  border-radius: 50%;

                  @media (min-width: 300px) and (max-width: 630px) {
                    display: flex;
                  }

                  img {
                    width: 22.9px;
                  }
                }
              }

              .tab.active {
                color: #04a5a5;

                background: #fff;

                .icon {
                  background: #1890a9;
                }
              }

              .tab:hover {
                color: #04a5a5;
              }
            }
          }
        }

        .tab-body {
          padding: 0px;
          width: 100%;
          border-radius: 0px !important;
          height: calc(100% - 117px);
          overflow-y: auto;
          display: flex;
          flex-direction: column;

          @media (min-width: 300px) and (max-width: 630px) {
            width: 100%;
            margin-top: 0px;
          }
        }
      }

      .profile-options {
        height: 100%;
        background: #fff;
        border-radius: 5px;
        height: 372px;

        .manage-consultant-profile-container {
          padding: 0px;
          margin-bottom: 42px;
          margin-top: 10px;

          @media (min-width: 300px) and (max-width: 630px) {
            width: 100%;
            margin-top: 0px;
          }

          .manager-info-widget {
            display: grid;
            grid-column-gap: 20px;
            grid-template-columns: 100%;
            border-bottom: 1px solid #ddd;
            padding: 4px 10px;

            @media (min-width: 300px) and (max-width: 630px) {
              display: grid;
              grid-column-gap: 20px;
              grid-template-columns: 100%;
              margin-bottom: 22px;
              padding: 0px 17px;
            }

            .manager-content {
              display: flex;
              align-items: center;
              justify-content: space-between;

              .profile-logo {
                img {
                  width: 50px;
                  height: 50px;
                  object-fit: contain;
                  border-radius: 50%;

                  @media (min-width: 300px) and (max-width: 630px) {
                    width: 100%;
                    width: 50px;
                    height: 50px;
                  }
                }
              }

              .profile-info {
                width: 90%;
                padding-left: 10px;

                h4 {
                  font-size: 15px;
                  margin: 0px;
                }

                .profile-location {
                  font-size: 13px;
                }
              }
            }
          }

          .manager-option {
            display: block;
            padding: 8px 15px;

            @media (min-width: 300px) and (max-width: 630px) {
              width: 100%;
              justify-content: space-between;
            }

            .btns {
              display: flex;

              .btn-export-cv {
                margin-right: 10px;
                width: 127px;
                height: 45px;
                background: #1890a9 0% 0% no-repeat padding-box;
                border-radius: 4px;
                color: #fff;
                outline: none;

                @media (min-width: 300px) and (max-width: 630px) {
                  font-size: 12px;
                  width: 106px;
                  height: 34px;
                }
              }

              .btn-back {
                margin-right: 10px;
                width: 127px;
                height: 45px;
                border: 1px solid #1890a9;
                border-radius: 4px;
                color: #1890a9;
                outline: none;

                @media (min-width: 300px) and (max-width: 630px) {
                  font-size: 12px;
                  width: 106px;
                  height: 34px;
                }
              }
            }

            .dropdown-menu {
              @media (min-width: 300px) and (max-width: 630px) {
                margin-top: 7px;
              }
            }
          }
        }
      }
    }

    .overlay-modal {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 99999;
      background: rgba(0, 0, 0, 0.8);
      display: flex;
      align-items: center;
      justify-content: center;

      .box-content {
        width: 400px;
        height: 200px;
        background: #fff;
        display: flex;
        flex-direction: column;
        border-radius: 5px;

        .content-widget {
          display: flex;
          align-items: center;
          justify-content: center;
          height: calc(100% - 45px);
          padding: 40px;

          p {
            text-align: center;
          }
        }

        .content-option {
          height: 45px;
          background: #04a5a5;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          border-bottom-left-radius: 5px;
          border-bottom-right-radius: 5px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>